/* nav-menu-list.tsx generated by @compiled/babel-plugin v0.29.1 */
import "./nav-menu-list.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { forwardRef } from 'react';
/**
 * This isn't needed within the platform package and will be cleaned up soon.
 *
 * @private
 * @deprecated
 */
export var NavMenuList = /*#__PURE__*/forwardRef(_NavMenuList);

// Placing this const below the function breaks Compiled!
var styles = {
  root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt4utpp"
};
function _NavMenuList(_ref, ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("ul", {
    ref: ref,
    className: ax([styles.root])
  }, children);
}